module.exports = require("ramda");